var MENU_POSITIONS = {
  TOP: 'top',
  MIDDLE: 'middle',
  BOTTOM: 'bottom'
};
var MENU_ALIGNMENTS = {
  LEFT: 'left',
  RIGHT: 'right'
};
var POPUP_POSITIONS = {
  TOP_LEFT: 'top left',
  TOP_RIGHT: 'top right',
  BOTTOM_LEFT: 'bottom left',
  BOTTOM_RIGHT: 'bottom right',
  MIDDLE_LEFT: 'middle left',
  MIDDLE_RIGHT: 'middle right'
};

/**
 * Генерирует массив позиций попапа на основе позиции и выравнивания меню
 *
 * @param menuPos - Позиция меню ('top', 'middle', 'bottom')
 * @param menuAlign - Выравнивание меню ('left', 'right')
 * @returns Массив позиций попапа в порядке приоритета
 *
 */
export function getMenuPositions(menuPos, menuAlign) {
  if (menuPos === undefined && menuAlign === undefined) {
    return [POPUP_POSITIONS.BOTTOM_LEFT, POPUP_POSITIONS.TOP_LEFT, POPUP_POSITIONS.BOTTOM_RIGHT, POPUP_POSITIONS.TOP_RIGHT];
  }
  if (menuPos !== undefined && menuAlign === undefined) {
    return [menuPos + " " + MENU_ALIGNMENTS.LEFT, menuPos + " " + MENU_ALIGNMENTS.RIGHT];
  }
  if (menuPos === undefined && menuAlign !== undefined) {
    return [MENU_POSITIONS.BOTTOM + " " + menuAlign, MENU_POSITIONS.TOP + " " + menuAlign];
  }
  return [menuPos + " " + menuAlign];
}